import { CommonModule } from '@angular/common';
import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { FormControl, FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { Question, Questionnaire } from '@app/core/models/questionnaire.model';

@Component({
  selector: 'app-short-text',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule,],
  templateUrl: './short-text.html',
  styleUrl: './short-text.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ShortText),
      multi: true
    }
  ]
})
export class ShortText {
  @Input() questionnaire: Questionnaire | null = null;
  @Input() question: Question | null = null;
  @Input() questionNumber: number = 0;
  @Input() isInvalid: boolean = false;
  @Input() errorMessage: string = '';
  @Input() formControl?: FormControl;
  @Input() inputType: 'text' | 'email' | 'password' | 'number' | 'tel' | 'url' | 'search' | 'date' | 'time' | 'datetime-local' | 'month' | 'week' = 'text';
  @Input() placeholder: string = 'Enter Your Response';
  /** Max length for text/number input (sets HTML maxlength and validates via form) */
  @Output() answerChange = new EventEmitter<any>();

  value: string = '';
  disabled: boolean = false;

  // ControlValueAccessor callbacks
  onChange = (value: string) => {};
  onTouched = () => {};

  ngOnInit() {
    if (this.formControl) {
      this.value = this.formControl.value ?? '';
      this.formControl.valueChanges.subscribe(value => {
        this.value = value ?? '';
      });
    }
  }

  writeValue(value: string): void {
    this.value = value || '';
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onInputChange(event: any) {
    const value = event.target.value;
    this.value = value;
    this.onChange(value);
    this.onTouched();

    // Emit with questionId and textResponse for the required payload format
    if (this.question?.questionId) {
      this.answerChange.emit({
        questionId: this.question.questionId,
        textResponse: value
      });
    }

    if (this.formControl) {
      this.formControl.setValue(value);
      this.formControl.markAsTouched();
    }
  }

  onBlur() {
    this.onTouched();
    if (this.formControl) {
      this.formControl.markAsTouched();
    }
  }
}
